<template>
    <div>
      <add-new-school :is-add-new-school-sidebar-active.sync="isAddNewSchoolSidebarActive"
        @sendschooldata="sendschooldata" />

        <add-edit-school :is-add-edit-school-sidebar-active.sync="isAddEditSchoolSidebarActive"
      :Editschoolid="Editschoolid" :Editschoolname="Editschoolname" :Editstaffcount="Editstaffcount"
      :Editschoolimg="Editschoolimg" :Editpremiumseats="Editpremiumseats" :Editpackageid="Editpackageid"
      :Editpackagename="Editpackagename" @clickeditschoolata="clickeditschoolata" />
  
     
      <b-card no-body>
        <div class="m-2">
          <b-row>
            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input v-model="searchQuery" class="d-inline-block mr-1" placeholder="Search..." />
                <b-button variant="primary" @click="isAddNewSchoolSidebarActive = true">
                  <span class="text-nowrap">Add School</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
  
        <b-card no-body class="mb-0">
          <b-table-simple hover caption-top responsive class="rounded-bottom mb-0">
            <b-thead head-variant="light">
              <b-tr>
                <b-th>No.</b-th>
                <b-th>School Image</b-th>
                <b-th>School Name</b-th>
                <b-th>Total Staff</b-th>
                <b-th>Premium Seats</b-th>
                <b-th>Package</b-th>
                <b-th>School Code</b-th>
                <b-th v-if="removeButtons == true">Custom Logo</b-th>
                <b-th v-if="removeButtons == true">Action</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <template v-for="(school, index) in getSchools()">
                <b-tr :key="index" v-if="school">
                    <!-- {{ school }} -->
                  <!-- <b-td>{{ school.schoolName }}</b-td> -->
                  <b-td>{{ index + 1 }}
                  </b-td>
  
                  <b-td>
                    <div v-if="school && school.schoolImg">
                        <template v-if="getFileExtensionFromUrl(school.schoolImg) === 'json'">
                            <LottieView :url="school.schoolImg" :forTopic="true" :key="keyForLottie" />
                        </template>

                        <template v-else-if="getFileExtensionFromUrl(school.schoolImg) === 'lottie'">
                            <DoLottieView :url="school.schoolImg" :forTopic="true"
                            :id="`subjects_${index}_${uuidv4()}`" :key="keyForLottie" />
                        </template>

                        <template v-else>
                            <img
                            :src="school.schoolImg || 'invalid_url.jpg'"
                            alt="School Image"
                            @error="imgError"
                            style="width: 100px; height: 100px"
                            />
                        </template>
                    </div>
                  </b-td>
                  <b-td>
                  <div v-if="school.schoolName">
                    <div>
                      <b-link 
                      :to="{
                        path: '/school-management/' + school._id,
                      }" @click="sendPropsToSchoolGrade(
                        school.schoolName,
                        school._id
                      )
                        ">
                        {{ school.schoolName }}
                      </b-link>
                    </div>
                  </div>
                </b-td>

                 <b-td>
                  <div v-if="school.staffCount">
                    <div>
                      {{ school.staffCount }}
                    </div>
                  </div>
                  <div v-else>
                      -
                  </div>
                </b-td>
                <b-td>
                  <b-badge v-if="school.premiumSeats > 0" variant="light-warning" pill>
                    <feather-icon icon="StarIcon" size="12" class="mr-25" />
                    {{ school.premiumSeats }}
                  </b-badge>
                  <span v-else class="text-muted">0</span>
                </b-td>
                <b-td>
                  <span v-if="school.packageName">{{ school.packageName }}</span>
                  <span v-else class="text-muted">-</span>
                </b-td>
                  <b-td>
                  <div v-if="school.staffCount">
                    <div>
                      {{ school.schoolCode }}
                    </div>
                  </div>
                   <div v-else>
                      -
                  </div>
                </b-td>
                  <!-- <b-td>
                    <div v-if="school ? school.schoolName : ''">
                    {{ school.schoolName }}<br />
                  </div>
                  </b-td>   -->
                  <b-td>
                      <b-form-checkbox 
                        v-model="school.customLogo"
                        switch
                        size="lg"
                        @change="statusChangeCustomLogo(school)"
                      >
                        <span class="sr-only">{{ school.customLogo ? 'Public' : 'Private' }}</span>
                      </b-form-checkbox>
                    </b-td>
                  <b-td v-if="removeButtons == true">
                    <b-dropdown variant="link" no-caret>
                      <template #button-content>
                        <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                      </template>
  
                      <b-dropdown-item @click="activeEditSchoolSidebar(school)
                        ">
                        <feather-icon icon="EditIcon" />
                        <span class="align-middle ml-50">Edit</span>
                      </b-dropdown-item>
  
                      <b-dropdown-item @click="activeDeleteSchoolSidebar(school._id)
                        ">
                        <feather-icon icon="TrashIcon" />
                        <span class="align-middle ml-50">Delete</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </b-td>
                </b-tr>
              </template>
            </b-tbody>
          </b-table-simple>
        </b-card>
      </b-card>
    </div>
  </template>
  
  <script>
  import {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BTableSimple,
    BThead,
    BTr,
    BTh,
    BTd,
    BTbody,
    BTfoot,
    BFormCheckbox
  } from "bootstrap-vue";
  import vSelect from "vue-select";
  import Swal from "sweetalert2/dist/sweetalert2.js";
  import "sweetalert2/src/sweetalert2.scss";
  import { BBreadcrumb } from "bootstrap-vue";
  import AddNewSchool from "./app/list/users-list/AddNewSchool";
  import AddEditSchool from "./app/list/users-list/AddEditSchool.vue";
  import axios from "axios";
  import Ripple from "vue-ripple-directive";
  import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
  import LottieView from "./components/question/LottieView.vue";
  import DoLottieView from "./components/question/DoLottieView.vue";
  import { v4 as uuidv4 } from 'uuid';
  export default {
    components: {
      BBreadcrumb,
      AddNewSchool,
      AddEditSchool,
      BCard,
      BRow,
      ToastificationContent,
      BCol,
      BFormInput,
      BButton,
      BTable,
      BMedia,
      BAvatar,
      BLink,
      BBadge,
      BDropdown,
      BDropdownItem,
      BPagination,
      BTooltip,
      BTableSimple,
      BThead,
      BTr,
      BTh,
      BTd,
      BTbody,
      BTfoot,
      vSelect,
      BFormCheckbox,
      LottieView,
      DoLottieView,
      uuidv4
    },
    directives: {
      Ripple,
    },
  
    data() {
      return {
        Editschoolid: "",
        Editschoolname: "",
        isAddNewSchoolSidebarActive: false,
        isAddEditSchoolSidebarActive: false,
        searchQuery: "",
        table_data: {},
        Editschoolimg: "",
        Editstaffcount: null,
        Editpremiumseats: 0,
        Editpackageid: null,
        Editpackagename: null,
        Editsubjectname: "",
        classId: this.$route.params.subjectsId,
        Editclassimg: "",
        Editsubjectimg: "",
        EditsubjectOrder: 0,
        Editsubjectplaytype:"",
        levelidedit: "",
        Editlevel: "",
        EditLevelname: "",
        EditNoofquestion: "",
        AddSubcategoryid: "",
        deletelevel: { delete_id: "" },
        perPage: 5,
        perPageOptions: [10, 25, 50, 100],
        routedata: this.$route.params.subcatId,
        alertData: "",
        deleteclassdata: {
          id: "",
        },
        deletesubjectdata: {
          class_id: "",
          subject_id: "",
        },
        toastMessage: '',
        removeButtons: "",
        keyForLottie: 0,
      };
    },
    mounted() {
      this.removeButtons = JSON.parse(localStorage.getItem("permission")).permission.some(permission => permission === "manage_subjects");
    },
    created() {
      this.gettabledata();
    },
    methods: {
      uuidv4,
      getFileExtensionFromUrl(url) {
        if (!url) return '';
        const path = url.split('?')[0].split('#')[0];
        const extension = path.split('.').pop();
  
        if (extension === path) return '';
  
        return extension;
      },
  
      imgError(event) {
        if (!event.target.dataset.errorHandled) {
          event.target.dataset.errorHandled = true;
          event.target.src = 'https://i.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.webp';
        }
      },
  
      statusChangeCustomLogo(subj) {
        console.log("testing", subj)
        axios
          .post(
            process.env.VUE_APP_API_URL + "/school/custom-logo/update",
            {
              _id: subj._id,
              customLogo: subj.customLogo
            },
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("_t"),
              },
            }
          )
          .then((response) => {
            this.toastMessage = "Custom Logo successfully update";
            this.toastNotification("success");
            this.gettabledata();
          })
          .catch((error) => {
            this.toastMessage = "Try Again";
            this.toastNotification("danger");
          });
      },
    activeDeleteSchoolSidebar: function (school_id) {
        // console.log('school ID', school_id)
        Swal.fire({
          title: "Are you sure?",
          text: "Do You want to delete this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteschooldata = school_id;
            console.log("deleteschooldata",this.deleteschooldata )
            // this.deletesubjectdata.subject_id = subject_id;
            axios.delete(process.env.VUE_APP_API_URL + "/deleteschooldata", {
                data: { school_id: this.deleteschooldata },
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("_t"),
                },
            })
              .then((response) => {
                if (response.data == "School not delete") {
                  this.alertData =
                    response.data + ".Please delete all the Category first";
                } else {
                  this.alertData = "School Deleted Successfully";
                }
                this.showToast("danger");
                this.gettabledata();
              });
          }
        });
      },
      showToast(variant) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: this.alertData,
            variant,
          },
        });
      },
      showToasted(variant) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: this.alertData,
            variant,
          },
        });
      },
      clickeditschoolata: function (SchoolData) {
        axios
          .put(
            process.env.VUE_APP_API_URL + "/school/update",
            SchoolData,
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("_t"),
              },
            }
          )
          .then((response) => {
            this.toastMessage = "School Successfully Edit";
            if (response.data && response.data.premium_revoked > 0) {
              this.toastMessage += `. Premium removed from ${response.data.premium_revoked} member(s) to fit the new seat count.`;
            }
            this.toastNotification("success");
            this.gettabledata();
          })
          .catch((error) => {
            this.toastMessage = this.getErrorMessage(error, "Try Again School Not Edit");
            this.toastNotification("danger");
          });
      },
  
      toastNotification(variant) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: this.toastMessage,
            variant,
          },
        });
      },
      sendschooldata: function (school_data) {
      //  console.log('sendschooldata', school_data )

        axios
          .post(process.env.VUE_APP_API_URL + "/school/create", school_data
            , {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("_t"),
              },
            }
          )
          .then((response) => {

            console.log("response", JSON.stringify(response.data.message, null, 2));
            
            if (response.data.message == "School created successfully") {
              this.subjectAdded("success");
              this.gettabledata();
            } else {
              this.subjectAddedRejected("danger");
            }
          })
          .catch((error) => {
            this.toastMessage = this.getErrorMessage(error, "School not added");
            this.toastNotification("danger");
          });
      },
      getErrorMessage(error, fallback) {
        const data = error && error.response && error.response.data;
        if (data) {
          if (data.errors) {
            const first = Object.values(data.errors)[0];
            if (Array.isArray(first) && first.length) return first[0];
          }
          if (data.message) return data.message;
          if (data.error) return data.error;
        }
        return fallback;
      },
      subjectAdded(variant) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "School added successfully",
            variant,
          },
        });
      },
      subjectAddedRejected(variant) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "School not added",
            variant,
          },
        });
      },
      activeEditSchoolSidebar(school) {
        console.log(school),
        this.isAddEditSchoolSidebarActive = true;
        this.Editschoolid = school._id;
        this.Editschoolname = school.schoolName;
        this.Editschoolimg = school.schoolImg;
        this.Editstaffcount = school.staffCount;
        this.Editpremiumseats = Number(school.premiumSeats) || 0;
        this.Editpackageid = school.packageId || null;
        this.Editpackagename = school.packageName || null;
      },

      gettabledata: function () {
        axios
          .get(process.env.VUE_APP_API_URL + `/school/all`, {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("_t"),
            },
          })
          .then((get_response) => {
            this.table_data = get_response.data.school;
            // console.log("get_response",get_response);

            this.keyForLottie += 1;
          });
      },
      getSchools() {
            if (this.searchQuery.trim().length > 0) {
                return this.table_data.filter((item) => {
                return item.schoolName && this.searchQuery
                    .toLowerCase()
                    .split(" ")
                    .every((v) => item.schoolName.toLowerCase().includes(v));
                });
            } else {
                return this.table_data;
            }
     },
     sendPropsToSchoolGrade(schoolName, schoolid) {
      let a = JSON.stringify(schoolName);
      localStorage.setItem("schoolName", a);
      let b = JSON.stringify(schoolid);
      localStorage.setItem("schoolid", b);
    },
    
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }
  
  .invoice-filter-select {
    min-width: 190px;
  
    ::v-deep .vs__selected-options {
      flex-wrap: nowrap;
    }
  
    ::v-deep .vs__selected {
      width: 100px;
    }
  }
  </style>
  
  <style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss";
  </style>
  